<template>
    <PageHeader :crumbs="[{ label: $t('portal.tickets.title') }]" />

    <div class="tw-p-2">
        <div class="tw-h-full tw-w-full tw-p-4 tw-bg-white tw-rounded tw-border tw-border-b-2 tw-min-h-[calc(100dvh-125px)]">
            <div class="tw-flex tw-items-center tw-justify-between tw-gap-2 tw-mb-4">
                <h2 class="tw-font-semibold tw-text-gray-700">{{ $t('portal.tickets.my-tickets') }}</h2>
                <a-button left-icon="heroicons:plus-16-solid" @click="createVisible = true">{{ $t('portal.tickets.new') }}</a-button>
            </div>

            <div v-if="loading" class="tw-py-10 tw-text-center tw-text-gray-400"><icon icon="line-md:loading-twotone-loop" class="tw-text-3xl" /></div>

            <ul v-else class="tw-space-y-2">
                <li v-for="t in items" :key="t.id"
                    class="tw-p-4 tw-rounded tw-border tw-border-solid tw-border-gray-200 tw-cursor-pointer tw-duration-200 hover:tw-border-primary-300 hover:tw-shadow-sm"
                    @click="goto(t)">
                    <div class="tw-flex tw-items-center tw-justify-between tw-gap-3">
                        <div class="tw-min-w-0 tw-flex tw-items-center tw-gap-2">
                            <span v-if="t.is_unread" class="tw-w-2 tw-h-2 tw-shrink-0 tw-rounded-full tw-bg-primary-500" :title="$t('portal.tickets.new-reply')"></span>
                            <div class="tw-min-w-0">
                                <p class="tw-font-semibold tw-text-gray-800 tw-truncate">{{ t.subject }}</p>
                                <p class="tw-text-xs tw-text-gray-400 tw-mt-0.5">{{ t.messages_count }} {{ $t('portal.tickets.messages') }} · {{ fmt.datetime(t.last_reply_at) }}</p>
                            </div>
                        </div>
                        <TicketStatusBadge :status="t.status" />
                    </div>
                </li>
                <li v-if="!items.length" class="tw-py-10 tw-text-center tw-text-gray-400">{{ $t('portal.tickets.none') }}</li>
            </ul>
        </div>
    </div>

    <NewTicketModal :visible="createVisible" @cancel="createVisible = false" @saved="onCreated" />
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { tickets as fetchTickets } from '@/api/portal';
import PageHeader from '@/components/PageHeader.vue';
import TicketStatusBadge from '@/views/admin/tickets/TicketStatusBadge.vue';
import NewTicketModal from './NewTicketModal.vue';
import { useFormat } from '@/composables/useFormat';
import { usePortalStore } from '@/stores';

const router = useRouter();
const fmt = useFormat();
const portalStore = usePortalStore();

const items = ref([]);
const loading = ref(false);
const createVisible = ref(false);

async function load() {
    loading.value = true;
    try {
        const { data } = await fetchTickets();
        items.value = data.tickets || [];
        // Keep the sidebar badge in sync with what the client sees.
        portalStore.setUnreadTickets(items.value.filter((t) => t.is_unread).length);
    } catch (e) { /* interceptor */ } finally {
        loading.value = false;
    }
}

const goto = (t) => router.push({ name: 'portal.tickets.show', params: { id: t.id } });

const onCreated = (ticket) => {
    createVisible.value = false;
    if (ticket?.id) {
        router.push({ name: 'portal.tickets.show', params: { id: ticket.id } });
    } else {
        load();
    }
};

load();
</script>
